export const getAuth = () =>
  JSON.parse(localStorage.getItem('access_token') || '{}')

export const storeAuth = auth =>
  localStorage.setItem('access_token', JSON.stringify(auth))

export const updateAuthCentro = centro => storeAuth({ ...getAuth(), centro })

export const removeAuth = () => localStorage.removeItem('access_token')

export const isAuthenticated = () => getAuth().token != null

export const isRolBrain = () => getAuth()?.rol === 'PROFESOR_BRAIN'

export const updateAuthFotoPerfil = foto => storeAuth({ ...getAuth(), foto })
